/* Homepage V4 behaviours: inside/outside tabs, scenario card flips, tap-to-play video cards. */
(function () {
  'use strict';
  if (window.__v4HomeInit) return;
  window.__v4HomeInit = true;
  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  ready(function () {
    // Inside vs. Outside tabs
    document.querySelectorAll('[data-v4-inout]').forEach(function (sec) {
      sec.querySelectorAll('[data-v4-side]').forEach(function (tab) {
        tab.addEventListener('click', function () {
          var side = tab.dataset.v4Side;
          sec.classList.toggle('is-outside', side === 'outside');
          sec.querySelectorAll('[data-v4-side]').forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-on', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
        });
      });
    });

    // Inside the Defender: flip a card between its outside and inside photo
    document.querySelectorAll('[data-v4-scene]').forEach(function (card) {
      var btn = card.querySelector('[data-v4-flip]');
      var state = card.querySelector('[data-v4-state]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var inside = !card.classList.contains('is-inside');
        card.classList.toggle('is-inside', inside);
        btn.setAttribute('aria-pressed', inside ? 'true' : 'false');
        btn.querySelector('span').textContent = inside ? btn.dataset.seeOutside : btn.dataset.seeInside;
        if (state) state.textContent = inside ? state.dataset.inside : state.dataset.outside;
      });
    });

    // Prev / next arrows for a horizontal strip (the strip is the next .v4-scroll after the arrows' section header)
    document.querySelectorAll('[data-v4-scrollnav]').forEach(function (nav) {
      var sec = nav.closest('section');
      var strip = sec && sec.querySelector('.v4-scroll');
      if (!strip) return;
      function step() { var card = strip.firstElementChild; return card ? card.getBoundingClientRect().width + 20 : strip.clientWidth * 0.8; }
      var prev = nav.querySelector('[data-v4-prev]');
      var next = nav.querySelector('[data-v4-next]');
      function sync() {
        if (prev) prev.disabled = strip.scrollLeft <= 2;
        if (next) next.disabled = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 2;
      }
      if (prev) prev.addEventListener('click', function () { strip.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { strip.scrollBy({ left: step(), behavior: 'smooth' }); });
      strip.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });

    // Video cards: tap to play (with sound), tap again to pause. One at a time. The speaker button mutes.
    var playing = null;
    document.querySelectorAll('[data-v4-video]').forEach(function (card) {
      var video = card.querySelector('video');
      var play = card.querySelector('.v4-vcard__play');
      var sound = card.querySelector('.v4-vcard__sound');
      if (!video || !play) return;
      function stop() { video.pause(); card.classList.remove('is-playing'); if (playing === video) playing = null; }
      function syncSound() {
        if (!sound) return;
        sound.setAttribute('aria-pressed', video.muted ? 'true' : 'false');
        sound.setAttribute('aria-label', video.muted ? 'Unmute' : 'Mute');
      }
      play.addEventListener('click', function () {
        if (playing && playing !== video) { playing.pause(); playing.closest('[data-v4-video]').classList.remove('is-playing'); }
        video.muted = false; // the tap is the user gesture browsers need before sound
        video.play().then(function () { card.classList.add('is-playing'); playing = video; syncSound(); }).catch(function () {
          video.muted = true; // sound refused (rare): play silent rather than not at all
          video.play().then(function () { card.classList.add('is-playing'); playing = video; syncSound(); }).catch(function () {});
        });
      });
      if (sound) sound.addEventListener('click', function (e) { e.stopPropagation(); video.muted = !video.muted; syncSound(); });
      video.addEventListener('click', stop);
      video.addEventListener('ended', stop);
    });
  });
})();
